import { MIN_WIDTH, MIN_HEIGHT } from '../constants/headerLogoImageSizes';

export const minSize = { width: MIN_WIDTH, height: MIN_HEIGHT };
